<template>
  <div class="binding">
    <mt-header title="账号绑定">
      <mt-button slot="left" icon="back">返回</mt-button>
    </mt-header>
    <div>
      
    </div>
    <div class="content">
      <div class="bindingWrap phone">
        <div class="phoneIcon">
          <icon name='mobile'></icon>
        </div>
        <div class="info">
          <p>手机账号绑定</p>
          <p>136*****321</p>
        </div>
        <div class="btn successBtn">已绑定></div>
      </div>
      <div class="bindingWrap wx">
        <div class="wxIcon">
          <icon name='weixin'></icon>
        </div>
        <div class="info">
          <p>微信登录绑定</p>
          <p></p>
        </div>
        <div class="btn">未绑定></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'binding',
  data () {
    return {
      msg: '消息'
    }
  },
  methods: {
    text: function () {
      alert('bbb')
    }
  }
}
</script>

<style scoped>
.bindingWrap{
  border-bottom: 1px solid #cccccc;
  padding:10px 5%;
}
.phoneIcon,.wxIcon{
  width: 30px;
  height: 30px;
  line-height: 35px;
  border-radius:5px;
  -webkit-border-radius:5px;
  -moz-border-radius:5px;
  background-color:#939393;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}
.bindingWrap .phoneIcon .fa-icon{
  color: #fff;
  transform: scale(2);
}
.bindingWrap .wxIcon .fa-icon{
  color: #fff;
  transform: scale(1.5);
}
.bindingWrap .info{
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
}
.bindingWrap .info p:nth-child(1){
  font-size: 14px;
}
.bindingWrap .info p:nth-child(2){
  font-size: 12px;
  color: #727272;
}
.bindingWrap .btn{
  font-size: 14px;
  color: #108ee9;
  float: right;
}
.phoneIcon{
  background-color: #108ee9;
}
.wx .success{
  background-color:#8dc91c;
}
.successBtn{
  color: #000!important;
}
</style>



// WEBPACK FOOTER //
// binding.vue?40ef0db6